import {Component, OnInit} from '@angular/core';
import {AbstractEditorComponent} from '../abstract-editor.component';
import {ValidatorEditorService} from '../validator-editor.service';
import {ValueEditor} from '../value-editor';
import {FormBuilder} from '@angular/forms';
import {FieldTableDto} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-text-editor',
    templateUrl: './text-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class TextEditorComponent extends AbstractEditorComponent implements OnInit {

    inputType: 'default' | 'number' | 'price' | 'email' = 'default';
    minFractionDigits = 0;
    maxLength = 0;
    mode: 'decimal'| 'currency' = 'decimal';

    constructor(protected validatorService: ValidatorEditorService,
                protected fb: FormBuilder) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return value;
    }

    ngOnInit(): void {
        this.init();
        this.maxLength = this.validatorService.getMaxLength(this.field.type);
        this.minFractionDigits = this.validatorService.getMinFractionDigits(this.field.type);
        if (this.minFractionDigits > 0) {
            this.mode = 'decimal';
        }
        if (this.field.categoryField === FieldTableDto.CategoryFieldEnum.NUMBER) {
            this.inputType = 'number';
        } else if (this.field.categoryField === FieldTableDto.CategoryFieldEnum.EMAIL) {
            this.inputType = 'email';
        } else if (this.field.categoryField === FieldTableDto.CategoryFieldEnum.PRICE) {
            this.inputType = 'price';
            this.mode = 'currency';
        }
    }

    
    onKeyDown() {
        this.formGroup.get('value').markAsDirty();
    }
}
